import { ComponentFactoryResolver, NgModule } from "@angular/core";
import { CoreModule } from "@obg/ngx.core";
import { RouterModule } from "@obg/ngx.router";
import { ComponentFactoryService } from "@obg/ngx.ui.core";

import { EmptyLayoutComponent } from "./empty-layout.component";

const ENTRY_COMPONENTS = [EmptyLayoutComponent];

@NgModule({
	imports: [CoreModule, RouterModule],
	exports: ENTRY_COMPONENTS,
	declarations: ENTRY_COMPONENTS,
})
export class EmptyLayoutModule {
	constructor(componentFactoryService: ComponentFactoryService, resolver: ComponentFactoryResolver) {
		componentFactoryService.registerLazyLoadedResolver(resolver, ...ENTRY_COMPONENTS);
	}
}
